import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    alignSelf: 'center',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: colorSet.gray000,
    height: 'calc(100%)',
    overflowX: 'visible',
    padding: '32px 0px 0px',
    '& > hr.MuiDivider-root': {
      height: 1,
      width: 552,
      background: colorSet.gray400,
      [theme.breakpoints.down('md')]: {
        width: '100%',
        height: 16,
        background: colorSet.gray200
      }
    },
    '& .history': {
      maxWidth: 600,
      width: '100%',
      padding: '0px 24px',
      [theme.breakpoints.down('md')]: {
        padding: '0px 16px'
      }
    }
  },

  containerTitle: {
    maxWidth: 600,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    paddingBottom: 0,
    [theme.breakpoints.down('md')]: {
      padding: '20px 16px'
    },
    '& .alignRow': {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'column',
      '&.iconButtonGroup': {
        gap: '8px',
        '& button': {
          padding: 6,
          '& svg': {
            fill: colorSet.gray800
          }
        }
      }
    }
  },
  priceBox: {
    padding: '32px 24px',
    maxWidth: 600,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    [theme.breakpoints.down('md')]: {
      padding: '24px 16px'
    },
    '& .price': {
      display: 'flex',
      justifyContent: 'space-between'
    },
    '& .amount': {
      marginTop: '2px',
      display: 'flex',
      justifyContent: 'space-between',
      '& p:last-child': {
        color: colorSet.primary500
      }
    },
    '& .divider': {
      background: colorSet.gray1000,
      margin: '4px 0'
    }
  },
  createOrderHeaderStepper: {
    width: '100%',
    height: '100px',
    padding: 25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottom: `1px solid ${colorSet.gray200}`,
    backgroundColor: colorSet.gray100,

    '& .MuiPaper-root': {
      backgroundColor: 'inherit',
      width: 416,
      '& .MuiStep-alternativeLabel': {
        padding: '0px 20px'
      }
    },
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  wrapper: {
    maxWidth: 600,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    '& .title': {
      fontSize: 16,
      fontWeight: 700,
      lineHeight: '25.6px',
      color: colorSet.gray900,
      marginBottom: 8
    },
    '& .pre-line': {
      whiteSpace: 'pre-line',
      wordBreak: 'break-all'
    },
    '&.user-info': {
      width: '100%',
      gap: '8px',
      padding: '32px 24px',
      [theme.breakpoints.down('md')]: {
        padding: '24px 16px'
      }
    },
    '&.gutter': {
      padding: '32px 24px',
      [theme.breakpoints.down('md')]: {
        padding: '24px 16px'
      }
    }
  }
}));

export default useStyles;
